/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import type { ValidatorMap } from "ember-changeset/types";
import type IntlService from "ember-intl/services/intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import HemodialysisSessionDeclaredJournalEvent from "parog-web/models/hemodialysis-session-declared-journal-event";

export default class HemodialysisSessionEditionFormComponent extends CrudJournalEventBaseComponent {
  @service declare intl: IntlService;
  @tracked
  currentState = "start";

  static forcDisplayName = "Séance d'hémodialyse";
  static fullComponentId = "hemodialysis-session/edition-form";

  static journalEventClass = HemodialysisSessionDeclaredJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  get variationWeight(): number | null {
    if (
      !(
        this.changeset.get("endOutputWeight") &&
        this.changeset.get("startDryWeight")
      )
    )
      return null;
    const variation =
      100 *
      ((this.changeset.get("endOutputWeight") -
        this.changeset.get("startDryWeight")) /
        this.changeset.get("startDryWeight"));
    return Math.round(variation * 100) / 100; //get 2 significant numbers
  }

  async save(): Promise<typeof this.journalEventClass> {
    this.changeset.set("endDryWeightVariation", this.variationWeight);
    return await super.save();
  }
}
